import { Typography, TableRow, TableCell } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { ElementType } from '@uplift/types';
import { Markdown } from '../../../../../../Markdown';

const useStyles = makeStyles()(theme => ({
  root: {

  },

  fullCellTitle: {
    fontWeight: 700,
    marginBottom: theme.spacing(2),
  },
  titleCell: {
    width: '70%',
    verticalAlign: 'top',
  },
  markdownWrapper: {
    '& h1': {
      fontSize: 'inherit',
      fontWeight: 'inherit',
    },
    '& h2': {
      fontSize: 'inherit',
      fontWeight: 'inherit',
    },
    '& h3': {
      fontSize: 'inherit',
      fontWeight: 'inherit',
    },
    '& h4': {
      fontSize: 'inherit',
      fontWeight: 'inherit',
    },
    '& h5': {
      fontSize: 'inherit',
      fontWeight: 'inherit',
    },
    '& h6': {
      fontSize: 'inherit',
      fontWeight: 'inherit',
    },
  },
  valueCell: {
    verticalAlign: 'top',
  },

  valueCellContent: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  list: {
    margin: 0,
    padding: 0,
  },
}));


export const AnswerRow = ({ title, value, type }: { title: string; value?: string | string[]; type: ElementType }) => {
  const { classes } = useStyles();

  if (type === 'short_answer') {
    return (
      <TableRow>
        <TableCell colSpan={2}>
          <Typography component="div" variant="body1" className={classes.fullCellTitle}>
            <div className={classes.markdownWrapper}>
              <Markdown>
                {title}
              </Markdown>
            </div>
          </Typography>
          <Typography component="div" variant="body1">{value || '–'}</Typography>
        </TableCell>
      </TableRow>
    );
  }

  if (Array.isArray(value) && value.length > 1) {
    return (
      <TableRow>
        <TableCell className={classes.titleCell}>
          <div className={classes.markdownWrapper}>
            <Markdown>
              {title}
            </Markdown>
          </div>
        </TableCell>
        <TableCell className={classes.valueCell}>
          <div className={classes.valueCellContent}>
            <ul className={classes.list}>
              {value.map(v =>
                <li key={v}>{v}</li>
              )}
            </ul>
          </div>
        </TableCell>
      </TableRow>
    );
  }

  return (
    <TableRow>
      <TableCell className={classes.titleCell}>
        <div className={classes.markdownWrapper}>
          <Markdown>
            {title}
          </Markdown>
        </div>
      </TableCell>
      <TableCell className={classes.valueCell}>
        <div className={classes.valueCellContent}>
          <span>
            {value || '–'}
          </span>
        </div>
      </TableCell>
    </TableRow>
  );
};
